export default "__VITE_ASSET__4ec26df3__"